const SERVER_ID = 'service_zm2nx4m'
const TEMPLATE_ID = 'template_2v8te4a'
const USER_ID = 'user_Dyit2y2iqiAfrAPrXx8Cq'
// const REG_NAME = /^[\S\b]+$/i

export { SERVER_ID, USER_ID, TEMPLATE_ID }
